import EmblaCarousel from 'embla';
import EmblaCarouselAutoplay from 'embla-autoplay';

class ComponentCanFeature extends HTMLElement {
  #carousel = null;
  #wrapper = null;
  #items = [];

  constructor() {
    super();

    this.onSelect = this.onSelect.bind(this);
  }

  onSelect() {
    const selected = this.#carousel.selectedScrollSnap();
    
    this.#items.forEach((item, index) => {
      item.setAttribute('data-active', index === selected ? 'true' : 'false');
    });
  }

  connectedCallback() {
    this.#wrapper = this.querySelector('[data-can-carousel]');
    this.#items = Array.from(this.#wrapper.querySelectorAll('[data-can-item]'));

    if (this.#wrapper) {
      this.initialize();
    }
  }

  initialize() {
    this.#carousel = EmblaCarousel(this.#wrapper, {
      loop: true,
      align: 'center',
      dragFree: false
    }, [
      EmblaCarouselAutoplay({
        startDelay: 0,
        delay: 6000
      })
    ]);

    this.#carousel.on('select', this.onSelect);
  }
}

if (!customElements.get('can-feature')) {
  customElements.define('can-feature', ComponentCanFeature);
}